import type { EventDefinition } from "./types.ts";

type ThemeFields = Pick<EventDefinition, "themeKey" | "themeScope" | "themeCooldownYears" | "themeMaxOccurrences">;

export function semanticLifeTheme(id: string, topic: string): ThemeFields {
  const value = `${id} ${topic}`.toLowerCase();
  if (/lottery|彩券|樂透/.test(value)) {
    return { themeKey: "life-lottery", themeScope: "person", themeCooldownYears: 7, themeMaxOccurrences: 3 };
  }
  if (/scam|fraud|trap|詐騙/.test(value)) {
    return { themeKey: "life-fraud-dispute", themeScope: "person", themeCooldownYears: 5, themeMaxOccurrences: 3 };
  }
  if (/guarantee|bad-loan|作保|擔保/.test(value)) {
    return { themeKey: "life-financial-guarantee", themeScope: "person", themeCooldownYears: 12, themeMaxOccurrences: 1 };
  }
  if (/loan|debt|借款|債務/.test(value)) {
    return { themeKey: "life-financial-debt", themeScope: "person", themeCooldownYears: 7, themeMaxOccurrences: 2 };
  }
  if (/inheritance|estate|property|遺產|繼承/.test(value)) {
    return { themeKey: "life-inheritance-property", themeScope: "person", themeCooldownYears: 8, themeMaxOccurrences: 2 };
  }
  if (/health|medical|hospital|surgery|illness|accident|健康|醫療|手術|生病/.test(value)) {
    return { themeKey: "life-health", themeScope: "person", themeCooldownYears: 3, themeMaxOccurrences: 6 };
  }
  if (/scholarship|mentor|audition|commission|award|opportunity|獎學金|甄選|機會/.test(value)) {
    return { themeKey: "life-opportunity", themeScope: "person", themeCooldownYears: 3, themeMaxOccurrences: 6 };
  }
  return { themeKey: `life-${topic}`, themeScope: "person", themeCooldownYears: 3, themeMaxOccurrences: 5 };
}

